// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDzq5k4w40Gq_lekFDASBRCSr7LyDAVGUQ",
    authDomain: "sites-259512.firebaseapp.com",
    databaseURL: "https://sites-259512.firebaseio.com",
    projectId: "sites-259512",
    storageBucket: "sites-259512.appspot.com",
    messagingSenderId: "539561663504",
    appId: "1:539561663504:web:7857afd3b3b8aa027d3e95"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
